// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"bff63725","611":"6f6109e7","761":"fd6151a1","947":"a611f495"}[chunkId] + ".chunk.js";
};